export const THEMES = {
    LIGHT: 'light',
    DARK: 'dark',
    LIGHT_ACCESSIBLE: 'light-accessible'
};

export const THEME_PREFERENCE_KEY = 'gc.web.theme';

export const COLOR_SCHEME_MAPPINGS = {
    [THEMES.LIGHT]: 'light',
    [THEMES.DARK]: 'dark',
    [THEMES.LIGHT_ACCESSIBLE]: 'light'
};

export const getColorSchemeForTheme = (theme) => {
    return COLOR_SCHEME_MAPPINGS[theme] || 'light';
};

export const getTheme = () => document.documentElement.getAttribute('data-theme') ?? THEMES.LIGHT;

export const isTheme = (theme) => getTheme() === theme;

export const isLightMode = () => getColorSchemeForTheme(getTheme()) === COLOR_SCHEME_MAPPINGS[THEMES.LIGHT];

export const isDarkMode = () => !isLightMode();
